import { useState } from 'react'

import reskillingBannerPc from '../../public/reskilling_banner_pc.png'
import reskillingBannerPcDetail from '../../public/reskilling_banner_detail_pc.png'

import reskillingBannerSp from '../../public/reskilling_banner_sp.png'
import reskillingBannerSpDetail from '../../public/reskilling_banner_detail_sp.png'

import reskillingPriceDescriptionDetail from '../../public/reskilling_price_description_detail.png'

type Props = {
  isPc: boolean
}

export const AwardContentReskilling = ({ isPc }: Props) => {
  const [showReskillingBannerDetail, setShowReskillingBannerDetail] =
    useState<boolean>(false)
  const [showPriceDescriptionDetail, setShowPriceDescriptionDetail] =
    useState<boolean>(false)

  const toggleReskillingBannerDetail = () => {
    setShowReskillingBannerDetail(!showReskillingBannerDetail)
  }

  const togglePriceDescriptionDetail = () => {
    setShowPriceDescriptionDetail(!showPriceDescriptionDetail)
  }

  return (
    <div className="flex flex-col gap-6">
      <div className="max-w-[750px] mx-auto relative">
        <div
          className={`absolute left-0 right-0 w-[378px] h-[27px] cursor-pointer desktop:${
            showReskillingBannerDetail ? 'top-[555px]' : 'bottom-1'
          } sp:${
            showReskillingBannerDetail ? 'top-[109vw]' : 'bottom-[1vw]'
          } sp:w-[76vw] sp:mt-6 sp:ml-[14px]`}
          onClick={toggleReskillingBannerDetail}
        ></div>
        {showReskillingBannerDetail ? (
          <>
            <a
              className="absolute w-[66px] h-[27px] left-[250px] right-0 top-[1126px] cursor-pointer sp:w-[14vw] sp:mt-6 sp:ml-[36vw] sp:top-[294vw]"
              href="https://shelikes.jp/landing_pages/price"
              target="_blank"
              rel="noreferrer"
            ></a>
            <div
              className={`absolute left-0 right-0 w-[220px] h-[27px] cursor-pointer desktop:${
                showPriceDescriptionDetail ? 'top-[1200px]' : 'bottom-[2px]'
              } sp:${
                showPriceDescriptionDetail ? 'top-[318vw]' : 'bottom-[2px]'
              } sp:w-[45vw] sp:mt-6 sp:ml-[14px]`}
              onClick={togglePriceDescriptionDetail}
            ></div>
            <div className="flex flex-col w-full">
              <img
                src={
                  isPc
                    ? reskillingBannerPcDetail.src
                    : reskillingBannerSpDetail.src
                }
                alt=""
                className="w-full h-auto block"
              />
              {showPriceDescriptionDetail && (
                <img
                  src={reskillingPriceDescriptionDetail.src}
                  alt=""
                  className="h-auto block mx-auto"
                  style={{
                    width: isPc ? '70%' : '90%',
                  }}
                />
              )}
            </div>
          </>
        ) : (
          <img
            src={isPc ? reskillingBannerPc.src : reskillingBannerSp.src}
            alt=""
          />
        )}
      </div>
    </div>
  )
}
